import Vue from 'vue'
import App from './App.vue'
import { router } from './router'
import Vant from 'vant'
import 'vant/lib/index.css'
import store from './store'
import VueTelInput from 'vue-tel-input'
import VueFilterDateFormat from 'vue-filter-date-format';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import * as VueGoogleMaps from "vue2-google-maps"
import vuetify from './plugins/vuetify';
import i18n from './locales/index'
// import VueCtkDateTimePicker from './plugins/VueCtkDateTimePicker'
import icons from "v-svg-icons";
import CrispChat from '@dansmaculotte/vue-crisp-chat'


Vue.use(Vant);
Vue.use(VueTelInput);
Vue.use(VueFilterDateFormat);
// Vue.use(VueCtkDateTimePicker)
Vue.component("icon", icons);

// Crisp chat
Vue.use(CrispChat, {
  websiteId: '49f6327e-5f6b-4baf-9cf3-ba48e34595c7',
  disabled: true,
  hideOnLoad: true
})
Vue.use(Loading, {
  color: '#ee2d24',
  width: 64,
  height: 64,
  backgroundColor: '#ffffff',
  opacity: 0.5,
  zIndex: 999,
  canCancel: false
});
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAWbfoUgZP24AaVw-yr2ZIEnaQQJHXWLGw",
    libraries: "places" // necessary for places input
  }
});

Vue.config.productionTip = false
// Vue.config.devtools = false 

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
